import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { VisitasService } from '../../../core/service/visitas.service';
import { CrearVisitasComponent } from '../crear-visitas/crear-visitas.component';

@Component({
  selector: 'app-listar-visitas',
  templateUrl: './listar-visitas.component.html',
  styleUrls: ['./listar-visitas.component.css']
})
export class ListarVisitasComponent implements OnInit {
  modalOptions: NgbModalOptions = {};
  visitas: any;
  id:any;
  constructor(
    private formBuilder: FormBuilder,
    private visitasService: VisitasService,
    private modalService: NgbModal
  ) {
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg'
    };
  }

  ngOnInit() {

    this.listarVisitas();
  }

  listarVisitas() {
    this.visitasService.visitasCliente().subscribe(data => {
      this.visitas = data.data;
      console.log('visitas', this.visitas);
    });
  }

  createVisita() {
    const modalRef = this.modalService.open(
      CrearVisitasComponent,
      this.modalOptions
    );
    modalRef.componentInstance.title = 'Crear nueva Visita';
    modalRef.result.then(result => {
      if (result) {
        this.listarVisitas();
      }
    });
  }
}
